declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveIvfCycleInseminationLogRequest, SaveOocyteMorphologyInfoRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from './searchprovider.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngbaddabnormaloqa',
  templateUrl: './addabnormaloqa.modal.html',
  styleUrls: ['./addabnormaloqa.modal.scss']
})

export class NgbAddAbnormalOqaModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() ActorCode;
  @Input() IsShowDetail: boolean = false;
  //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() CurrentSaveIvfCycleInseminationLogRequest: SaveIvfCycleInseminationLogRequest;
  @Input() ServiceCode: number;
  @Input() CycleCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
  public maxDate: NgbDateStruct;
    public minDate: NgbDateStruct;
   
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  CurrentSaveOocyteMorphologyInfoRequest: SaveOocyteMorphologyInfoRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private spinner: NgxSpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
      private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
    //this.CurrentActorAddEmergencyInfoRequest = new SaveEmergencyContactInfoRequest();
    //this.CurrentActorAddEmergencyInfoRequest.ConditionalOperator = 10;
    //this.CurrentActorAddEmergencyInfoRequest.ActorCode = this.ActorCode;
    //this.CurrentActorAddEmergencyInfoRequest.EmergencyContactCode = 0;
    //this.CurrentActorAddEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.ShowService = false;
    this.CurrentSaveOocyteMorphologyInfoRequest = new SaveOocyteMorphologyInfoRequest();
    this.CurrentSaveOocyteMorphologyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

    onSubmit() {
      this.spinner.show();
        this.CurrentSaveOocyteMorphologyInfoRequest.CycleCode = this.CycleCode;



        this.CurrentSaveOocyteMorphologyInfoRequest.ConditionalOperator = 10;
        this.CurrentSaveOocyteMorphologyInfoRequest.CycleOocyteMorphologyCode = 0;
        this.actorservice.SaveOocyteMorphologyInfo(this.CurrentSaveOocyteMorphologyInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                      this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                      this.spinner.hide();
                        this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                      this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                      this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                      this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                      this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
